import React, { useEffect, useState } from "react";
import styles from "./arcana.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import Footer from "../../components/footer/footer";
import FilterSelect from "../../components/filter-select/filter-select";
import SearchBox from "../../components/search-box/search-box";
import { changeFilter } from "../../store/reducers/list/arcanaList";
import FavorateButton from "../../components/buttons/favorate-button/favorate-button";
import Card from "../../components/arcana/card";
import ArcanaDescModal from "../../components/arcana/modal/arcana-desc-modal";
import Checkbox from "../../components/checkbox/checkbox";
import {
    selectArcanaEntities,
    selectArcanaFavorites,
    selectArcanaFilter,
    selectVisibleArcanas,
} from "../../store/selectors/arcanaSelectors";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import { loadData } from "../../functions/dataLoader";
import FILTERS from "../../config/filter_config.json";

export default function Arcana() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);
    // const [FILTERS, setFILTERS] = useState(null);

    // useEffect(() => {
    //     // setFILTERS(getData("filter_config"));
    //     loadData("filter_config").then(setFILTERS);
    // }, []);

    // if (!FILTERS) return;

    const [query, setQuery] = useState("");
    const [isFavorite, setIsFavorite] = useState(false);
    const [isOffImage, setIsOffImage] = useState(localStorage.getItem("off_image") === "true");

    const [selected, setSelected] = useState();
    const [isActive, setIsActive] = useState(false);

    const navigate = useNavigate();

    const arcanaIds = useSelector((state) => selectVisibleArcanas(state, query));
    const favorites = useSelector((state) => selectArcanaFavorites(state));
    const arcanaEntites = useSelector((state) => selectArcanaEntities(state));
    const arcanaFilter = useSelector((state) => selectArcanaFilter(state));

    const toggleImage = () => {
        const value = !isOffImage;

        localStorage.setItem("off_image", value);
        setIsOffImage(value);
    };

    const openModal = (arcana) => {
        navigate(`/arcana/${arcana.id}`);
    };

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.arcana")} />
            <div className={styles["arcana-container"]}>
                <div className={styles["filters-wrapper"]}>
                    <div className={styles["filters"]}>
                        <FilterSelect
                            id={"rarity"}
                            list={lang === LOCALES.KO ? FILTERS.ARCANA_RARITY : FILTERS.ARCANA_RARITY_ENG}
                            selected={arcanaFilter.rarity}
                            changeFilter={changeFilter}
                        />
                        <FilterSelect
                            id={"status"}
                            list={lang === LOCALES.KO ? FILTERS.STATUS : FILTERS.STATUS_ENG}
                            selected={arcanaFilter.status}
                            changeFilter={changeFilter}
                        />
                    </div>
                    <div className={styles["search-boxes"]}>
                        <SearchBox changeQuery={setQuery} placeholder={getUIText(lang, "search.arcana")} />
                        <FavorateButton isFavorite={isFavorite} setIsFavorite={setIsFavorite} />
                    </div>
                </div>
                <div className={styles["checkers"]}>
                    <Checkbox value={isOffImage} setValue={toggleImage} text={getUIText(lang, "check.arcana.hideImage")} />
                </div>
                <div className={styles["arcana-list-container"]}>
                    {isFavorite
                        ? favorites.map((id) => {
                              const arcana = arcanaEntites[id];
                              return (
                                  <Card
                                      lang={lang}
                                      arcana={arcana}
                                      isOffImage={isOffImage}
                                      clickEvent={openModal}
                                      showFavorite={true}
                                      key={`arcana_list_${arcana.id}`}
                                  />
                              );
                          })
                        : arcanaIds.map((id) => {
                              const arcana = arcanaEntites[id];
                              return (
                                  <Card
                                      lang={lang}
                                      arcana={arcana}
                                      isOffImage={isOffImage}
                                      clickEvent={openModal}
                                      showFavorite={true}
                                      key={`arcana_list_${arcana.id}`}
                                  />
                              );
                          })}
                </div>
            </div>
            <ArcanaDescModal lang={lang} isActive={isActive} setIsActive={setIsActive} selected={selected} />
            <ScrollUpButton />
            <Footer />
        </div>
    );
}
